// src/services/api/courierUploadFormat.js
import { apiClient } from './base';

/**
 * Get courier upload format with mapped order data
 * @param {Object} params - Query parameters
 * @param {number} params.packingBatchId - Get orders from specific packing batch (optional)
 * @param {number} params.businessCourierId - Business courier account (required if no packingBatchId)
 * @param {string} params.dispatchedDate - Date to filter dispatched orders (required if no packingBatchId, YYYY-MM-DD)
 * @returns {Promise<Object>} Upload format data with orders
 */
export const getCourierUploadFormat = async (params = {}) => {
  try {
    const response = await apiClient.get('/courier-upload-format/upload-format', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get recent packing batches for dropdown (last 30 days)
 * @returns {Promise<Object>} List of recent packing batches
 */
export const getRecentPackingBatches = async () => {
  try {
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    
    const response = await apiClient.get('/packing-batches', {
      params: {
        limit: 100,
        dateFrom: thirtyDaysAgo.toISOString().split('T')[0]
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};